<c-row>
  <c-col xs="12">
    <c-card class="mb-4 shadow">
      <c-card-header ngPreserveWhitespaces>
        <c-row>
          <c-col>
            <strong>Partners</strong>
          </c-col>
        </c-row>
      </c-card-header>
      <c-card-body>
        <c-col xs="12">
          <button
            cButton
            color="primary"
            variant="outline"
            (click)="toggleModal()"
          >
            New Partner
          </button>
          <c-alert
            fade
            *ngIf="msg"
            color="{{
              msg.isSuccess !== undefined
                ? msg.isSuccess
                  ? 'success'
                  : 'danger'
                : msg.IsSuccess
                ? 'success'
                : 'danger'
            }}"
            class="d-flex align-items-center mt-2"
          >
            <svg
              cIcon
              size="xl"
              name="{{
                msg.isSuccess !== undefined
                  ? msg.isSuccess
                    ? 'cilCheckCircle'
                    : 'cilWarning'
                  : msg.IsSuccess
                  ? 'cilCheckCircle'
                  : 'cilWarning'
              }}"
            ></svg>
            <div style="margin-left: 10px">
              {{ msg.Message !== undefined ? msg.Message : msg.message }}
            </div>
          </c-alert>
          <c-smart-table
            [activePage]="1"
            [columnSorter]="true"
            [columns]="UsersColumns"
            [itemsPerPageSelect]="true"
            tableFilterPlaceholder="Type Here"
            [itemsPerPage]="10"
            [items]="UsersData"
            [sorterValue]="{ column: 'name', state: 'asc' }"
            [tableFilter]="false"
            tableFilterLabel="  Search:"
            [tableProps]="{ hover: true, responsive: true }"
            [tableBodyProps]="{ align: 'middle' }"
            clickableRows
            header
            pagination
            [loading]="Loading"
            (rowClick)="OpenUserPage($event)"
          >
            <ng-template cTemplateId="tableDetails" let-item="item">
              <div
                [visible]="this.details_visible[item._id] === true"
                cCollapse
              >
                <c-card class="rounded-0">
                  <c-card-footer>
                    <div>
                      <button
                        cButton
                        class="ms-1"
                        color="primary"
                        variant="outline"
                        style="padding: 5px 10px; margin-left: 100px"
                        size="sm"
                        (click)="EditUser(item)"
                      >
                        Edit Details
                      </button>
                      <button
                        cButton
                        class="ms-1"
                        color="danger"
                        variant="outline"
                        style="padding: 5px 10px; margin-left: 100px"
                        size="sm"
                        (click)="DeleteUser(item)"
                      >
                        Delete
                      </button>
                    </div>
                  </c-card-footer>
                </c-card>
              </div>
            </ng-template>
            <ng-template
              cTemplateId="tableData"
              let-columnName="columnName"
              let-item="item"
              let-tdContent="tdContent"
            >
              <td>
                <ng-container [ngSwitch]="columnName">
                  <ng-container *ngSwitchCase="'Actions'" class="py-2">
                    <button
                      (click)="toggleDetails(item._id)"
                      cButton
                      color="primary"
                      size="sm"
                      variant="outline"
                    >
                      Actions
                    </button>
                  </ng-container>
                  <ng-container *ngSwitchCase="'productImagePath'" class="py-2">
                    <!-- <img
                        cImg
                        rounded
                        [src]="baseService.PRODUCTIMAGESURL + tdContent"
                        alt="Image"
                        class="img-fluid"
                        height="40"
                      /> -->
                  </ng-container>
                  <ng-container *ngSwitchCase="'isActive'" class="py-2">
                    {{ tdContent ? "Active" : "Inactive" }}
                  </ng-container>
                  <ng-container *ngSwitchCase="'isApproved'" class="py-2">
                    {{ tdContent ? "Yes" : "No" }}
                  </ng-container>
                  <ng-container *ngSwitchCase="'picture'" class="py-2">
                    <div class="text-start">
                      <!-- <c-avatar  [src]="baseService.USERIMAGESURL + tdContent" ></c-avatar> -->
                      <app-autoavatar
                        [UserData]="item"
                        [Header]="false"
                      ></app-autoavatar>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'CreditLimit'" class="py-2">
                    <div class="text-end">
                      {{ tdContent | currency : "$" }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'RMHID'" class="py-2">
                    <div class="text-end">
                      {{ tdContent }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    {{ tdContent }}
                  </ng-container>
                </ng-container>
              </td>
            </ng-template>
          </c-smart-table>
        </c-col>
      </c-card-body>
    </c-card>
  </c-col>
</c-row>

<!-- Add User -->
<c-modal
  #AddUser
  alignment="center"
  id="AddUser"
  backdrop="static"
  [visible]="ModalVisible"
>
  <c-modal-header>
    <h5 cModalTitle>User Details</h5>
    <button (click)="toggleModal()" cButtonClose></button>
  </c-modal-header>
  <c-modal-body>
    <form
      #ProductDetailsForm="ngForm"
      (ngSubmit)="
        EditMode
          ? updateUser(ProductDetailsForm, UsersService.UserData)
          : AddUserCall(ProductDetailsForm, UsersService.UserData)
      "
      [gutter]="3"
      [validated]="customStylesValidated"
      novalidate
      cForm
      cRow
      class="needs-validation"
    >
      <!-- <c-col [md]="12">
          <label cLabel for="products_Id">Product *</label>
          <select
            cSelect
            id="products_Id"
            name="products_Id"
            [(ngModel)]="UsersService.UserData.products_Id"
          >
            <option disabled>Choose</option>
            <option *ngFor="let product of ProductsData" [value]="product.id">
              {{ product.productName }}
            </option>
            <c-form-feedback [valid]="true">Looks good!</c-form-feedback>
          </select>
        </c-col> -->
      <!-- <c-col [md]="6">
          <label cLabel for="Username">Username *</label>
          <input
            cFormControl
            id="Username"
            name="Username"
            required
            type="text"
            oninput="this.value = this.value.replace(/\s/g, '')"
            [(ngModel)]="UsersService.UserData.userName"
          />
          <c-form-feedback [valid]="true">Looks good!</c-form-feedback>
          <c-form-feedback [valid]="false">Username Required</c-form-feedback>
        </c-col> -->
      <c-col [md]="6">
        <label cLabel for="firstName">First Name *</label>
        <input
          cFormControl
          id="firstName"
          name="firstName"
          required
          type="text"
          [(ngModel)]="UsersService.UserData.firstName"
        />
        <c-form-feedback [valid]="true">Looks good!</c-form-feedback>
        <c-form-feedback [valid]="false">First Name is Required</c-form-feedback>
      </c-col>
      <c-col [md]="6">
        <label cLabel for="lastName">Last Name *</label>
        <input
          cFormControl
          id="lastName"
          name="lastName"
          required
          type="text"
          [(ngModel)]="UsersService.UserData.lastName"
        />
        <c-form-feedback [valid]="true">Looks good!</c-form-feedback>
        <c-form-feedback [valid]="false">Last Name is Required</c-form-feedback>
      </c-col>
      <c-col [md]="12">
        <label cLabel for="Email">Email *</label>
        <input
          cFormControl
          id="Email"
          name="Email"
          required
          type="email"
          [(ngModel)]="UsersService.UserData.emailAddress"
          (focusout)="checkUserName($event.target.value, ProductDetailsForm)"
        />
        <div
          class="text-danger"
          style="font-size: 12px"
          *ngIf="ProductDetailsForm.controls.Email?.errors?.EmailExists"
        >
          Email Already Exist
        </div>
        <c-form-feedback [valid]="true">Looks good!</c-form-feedback>
        <c-form-feedback [valid]="false">Email is Required</c-form-feedback>
      </c-col>
      <!-- <c-col [md]="6">
          <label cLabel for="Password">Password *</label>
          <div class="input-group">
            <input
              cFormControl
              id="Password"
              name="Password"
              required
              type="{{ showPassword ? 'text' : 'password' }}"
              pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*^#?&.(=)+-\s])([A-Za-z\d@$!%*^#?&.(=)+-\s]{8,})$"
              title="Hint: Minimum 8 characters i.e Lower & Upper case, Numbers and Special characters"
              [(ngModel)]="UsersService.UserData.password"
            />
            <button
              type="button"
              class="btn btn-light"
              (click)="togglePasswordVisibility()"
            >
              <img
                cIcon
                [src]="
                  showPassword
                    ? 'assets/images/avatars/hide.png'
                    : 'assets/images/avatars/show.png'
                "
              />
            </button>
            <c-form-feedback [valid]="true">Looks good!</c-form-feedback>
            <c-form-feedback [valid]="false"
              >Password is Required and must contain at least 8 characters
              including lowercase and uppercase letters, numbers, and special
              characters.</c-form-feedback
            >
          </div>
        </c-col> -->
      <!-- <c-col [md]="6">
        <label cLabel for="PhoneNumber">Phone Number *</label>
        <input
          cFormControl
          id="PhoneNumber"
          name="PhoneNumber"
          pattern="^[0-9\s\(\)\+\-]+$"
          (keypress)="validatePhoneNumberInput($event)"
          required
          type="text"
          [(ngModel)]="UsersService.UserData.mobilePhoneNumber"
        />
        <c-form-feedback [valid]="true">Looks good!</c-form-feedback>
        <c-form-feedback [valid]="false"
          >Phone Number is Required</c-form-feedback
        >
      </c-col> -->
      <!-- <c-col [md]="6">
          <label cLabel for="UserImage">Profile Picture</label>
          <input
            cFormControl
            #imageField
            id="UserImage"
            name="UserImage"
            type="file"
            (change)="onFileSelected($event)"
            [cPopover]="popoverHtml"
            cPopoverPlacement="right"
            [cPopoverTrigger]="'hover'"
          />
          <ng-template #popoverHtml>
          
            <div class="popover-body">
              <div
                class="text-center"
                style="width: 10vw; height: 10vh"
                *ngIf="fileSelected"
              >
                <img
                  cImg
                  rounded
                  [src]="imageSrc"
                  alt="Slider Image"
                  class="img-fluid"
                  width="100%"
                  height="100%"
                  style="object-fit: contain"
                />
              </div>
              <div
                class="text-center"
                style="width: 10vw; height: 10vh"
                *ngIf="!fileSelected && UsersService.UserData.picture"
              >
                <img
                  cImg
                  rounded
                  [src]="
                    baseService.PRODUCTIMAGESURL + UsersService.UserData.picture
                  "
                  alt="Slider Image"
                  class="img-fluid"
                  width="100%"
                  height="100%"
                  style="object-fit: contain"
                />
              </div>
              <div
                class="text-center"
                style="width: 10vw; height: 10vh"
                *ngIf="!fileSelected && !UsersService.UserData.picture"
              >
                <p>Image not Selected</p>
              </div>
            </div>
          </ng-template>
          <c-form-feedback [valid]="true">Looks good!</c-form-feedback>
        </c-col> -->
      <!-- <c-col [md]="6">
        <label cLabel for="Address">Address *</label>
        <input
          cFormControl
          id="Address"
          name="Address"
          required
          type="text"
          [(ngModel)]="UsersService.UserData.address"
        />
        <c-form-feedback [valid]="true">Looks good!</c-form-feedback>
        <c-form-feedback [valid]="false">Address is Required</c-form-feedback>
      </c-col> -->

      <!-- <c-col [md]="12">
          <label cLabel for="dependencyID">Dependency Id *</label>
          <select
            cSelect
            id="dependencyID"
            name="dependencyID"
            [(ngModel)]="UsersService.UserData.dependencyID"
          >
            <option disabled>Choose</option>
            <option *ngFor="let User of UsersData" [value]="User.id">
              {{ User.UserName }}
            </option>
            <c-form-feedback [valid]="true">Looks good!</c-form-feedback>
          </select>
        </c-col> -->
      <!-- <c-col [xs]="5"></c-col>
      <c-col [xs]="7">
        <c-form-check [switch]="true">
          <input
            cFormCheckInput
            id="isActive"
            name="isActive"
            type="checkbox"
            [(ngModel)]="UsersService.UserData.isActive"
          />
          <label cFormCheckLabel for="isActive">Active *</label>
        </c-form-check>
      </c-col> -->
      <c-col [xs]="12">
        <div class="text-end">
          <button cButton color="primary" variant="outline" type="submit" [disabled]="ButtonLoading">
            <c-spinner
              aria-hidden="true"
              size="sm"
              *ngIf="ButtonLoading"
            ></c-spinner>
            Save
          </button>
        </div>
      </c-col>
    </form>
  </c-modal-body>
</c-modal>
